module.exports = __webpack_public_path__ + "static/media/landing-footer-lightblue.b4a3e6ec.webp";